import { useCallback, useState } from 'react';
import { FORM_FIELDS_MAP, SOURCES } from 'features/new-candidate/constants';
import useDebounce from 'hooks/debounce';
import { useCheckEmail } from 'hooks/useCheckEmail';
import flatMap from 'lodash/flatMap';
import map from 'lodash/map';
import { DELAY_BOUNCE_TIME } from 'UI/constants/defaults';
import { selectValidation } from 'UI/utils/forms';

export const useDataSheet = ({ setValue }) => {
  const [isDataSheetOpen, setIsDataSheetOpen] = useState(false);

  const openDataSheet = () => {
    setIsDataSheetOpen(true);
  };

  const closeDataSheet = () => {
    setIsDataSheetOpen(false);
  };

  const handleSaveCandidateDataSheet = useCallback(
    (candidateDataSheetID, progress) => {
      setValue(FORM_FIELDS_MAP.DataSheet.key, { id: candidateDataSheetID, progress });
    },
    [setValue]
  );

  return {
    closeDataSheet,
    handleSaveCandidateDataSheet,
    isDataSheetOpen,
    openDataSheet
  };
};

export const useAttachments = ({ initialAttachments }) => {
  const [attachments, setAttachments] = useState(initialAttachments ?? []);

  const handleAttachmentsChanged = useCallback(data => {
    const attachmentsChanged = flatMap(map(data, 'files'));
    setAttachments(attachmentsChanged);
    return attachmentsChanged;
  }, []);

  return {
    attachments,
    handleAttachmentsChanged
  };
};

export const useRegisteredEmails = ({ email, isFromDirectory, isFromTalentPool, otherEmail }) => {
  const debouncedEmail = useDebounce(email ?? '', DELAY_BOUNCE_TIME).trim();
  const debouncedOtherEmail = useDebounce(otherEmail ?? '', DELAY_BOUNCE_TIME).trim();

  const { validation: emailVerification, initialData } = useCheckEmail({
    debouncedEmail,
    hasEmail: !!email,
    isFromTalentPool,
    shouldCheckContacts: !isFromDirectory
  });

  const { validation: otherEmailVerification } = useCheckEmail({
    debouncedEmail: debouncedOtherEmail,
    hasEmail: !!otherEmail,
    isFromTalentPool,
    shouldCheckContacts: !isFromDirectory
  });

  const emailsValidation = selectValidation(
    { ...emailVerification, email: debouncedEmail },
    { ...otherEmailVerification, email: debouncedOtherEmail },
    initialData
  );

  return emailsValidation;
};
